/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Password_LengthInputs */

const en_login_error_password_length = /** @type {(inputs: Login_Error_Password_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password must be at least 6 characters long`)
};

const fr_login_error_password_length = /** @type {(inputs: Login_Error_Password_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le mot de passe doit contenir au moins 6 caractères`)
};

const de_login_error_password_length = /** @type {(inputs: Login_Error_Password_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Passwort muss mindestens 6 Zeichen lang sein.`)
};

const it_login_error_password_length = /** @type {(inputs: Login_Error_Password_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La password deve essere lunga almeno 6 caratteri`)
};

const ru_login_error_password_length = /** @type {(inputs: Login_Error_Password_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пароль должен состоять не менее чем из 6 символов.`)
};

const es_login_error_password_length = /** @type {(inputs: Login_Error_Password_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La contraseña debe tener al menos 6 caracteres.`)
};

const zh_cn2_login_error_password_length = /** @type {(inputs: Login_Error_Password_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码长度必须至少为 6 个字符。`)
};

const ja_login_error_password_length = /** @type {(inputs: Login_Error_Password_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードは6文字以上でなければなりません`)
};

const hi_login_error_password_length = /** @type {(inputs: Login_Error_Password_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पासवर्ड कम से कम 6 अक्षरों का होना चाहिए`)
};

const pt_pt2_login_error_password_length = /** @type {(inputs: Login_Error_Password_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A senha deve ter pelo menos 6 caracteres.`)
};

/**
* | output |
* | --- |
* | "Password must be at least 6 characters long" |
*
* @param {Login_Error_Password_LengthInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_password_length = /** @type {((inputs?: Login_Error_Password_LengthInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Password_LengthInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_error_password_length(inputs)
	if (locale === "de") return de_login_error_password_length(inputs)
	if (locale === "it") return it_login_error_password_length(inputs)
	if (locale === "ru") return ru_login_error_password_length(inputs)
	if (locale === "es") return es_login_error_password_length(inputs)
	if (locale === "zh-CN") return zh_cn2_login_error_password_length(inputs)
	if (locale === "ja") return ja_login_error_password_length(inputs)
	if (locale === "hi") return hi_login_error_password_length(inputs)
	if (locale === "pt-PT") return pt_pt2_login_error_password_length(inputs)
	return en_login_error_password_length(inputs)
});